const DEFAULT_MESSAGES = {
  'bad-request': 'The request could not be processed.',
  unauthorized: 'Your session has expired. Sign in again.',
  forbidden: 'You do not have permission to do that.',
  'not-found': 'Not found.',
  conflict: 'This record changed elsewhere. Reload to see the latest.',
  network: 'Could not reach the server. Check your connection and try again.',
  server: 'The server encountered an error. Please try again.',
  unknown: 'Something went wrong.'
};
export class ApiError extends Error {
  constructor(kind, status, serverMessage, raw) {
    super(serverMessage || DEFAULT_MESSAGES[kind]);
    this.name = 'ApiError';
    this.kind = kind;
    this.status = status;
    this.serverMessage = serverMessage;
    if (raw && raw.data !== undefined) this.data = raw.data;
    if (raw && raw.statusText !== undefined) this.statusText = raw.statusText;
    if (raw && typeof raw.headers === 'function') this.headers = raw.headers;
  }
}
function kindForStatus(status) {
  if (status === 400) return 'bad-request';
  if (status === 401) return 'unauthorized';
  if (status === 403) return 'forbidden';
  if (status === 404) return 'not-found';
  if (status === 409) return 'conflict';
  if (status === 0) return 'network';
  if (status >= 500) return 'server';
  return 'unknown';
}
function extractServerMessage(data) {
  if (typeof data === 'string' && data.length > 0) return data;
  if (Array.isArray(data)) {
    const first = data[0];
    return typeof first === 'string' && first.length > 0 ? first : undefined;
  }
  if (data !== null && typeof data === 'object') {
    const message = data.error ?? data.message;
    if (typeof message === 'string' && message.length > 0) return message;
  }
  return undefined;
}
export function toApiError(rejection) {
  if (rejection instanceof ApiError) return rejection;
  if (rejection !== null && typeof rejection === 'object' && 'status' in rejection) {
    const status = typeof rejection.status === 'number' && Number.isFinite(rejection.status) ? rejection.status : 0;
    return new ApiError(kindForStatus(status), status, extractServerMessage(rejection.data), {
      data: rejection.data,
      statusText: typeof rejection.statusText === 'string' ? rejection.statusText : undefined,
      headers: typeof rejection.headers === 'function' ? rejection.headers : undefined
    });
  }
  const message = rejection instanceof Error ? rejection.message : undefined;
  return new ApiError('network', 0, message);
}